import { Component } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { environment } from '../../../environments/environment';
import { ImageCardComponent } from "../image-card/image-card.component";
import { CountUpModule } from 'ngx-countup';
import { CountUpOptions } from 'countup.js';
@Component({
    selector: 'app-content-card',
    imports: [CommonModule, NgOptimizedImage, ImageCardComponent, CountUpModule],
    templateUrl: './content-card.component.html',
    styleUrl: './content-card.component.scss',
    host: { ngSkipHydration: 'true' },

})
export class ContentCardComponent {
    ngOnInit() {
        this.useOptionsAndEndVal();
    }
    ngAfterViewInit() {
        this.delay = false;
        setTimeout(() => {
            this.delay = true;
        }, 500);
    }

    opts: CountUpOptions = {
        enableScrollSpy: true,
    };
    opts1: CountUpOptions = {
        enableScrollSpy: true,
    };
    delay: boolean = false;
    assetsCDNUrl = environment.assetsCDNUrl;
    items = [
        {
            headingPre: '',
            heading: 4650,
            headingBasic: false,
            headingPost: '+',
            para: 'Branch Network across India'
        },
        {
            headingPre: '',
            heading: 116500,
            headingBasic: false,
            headingPost: '+',
            para: 'Employees'
        },
        {
            headingPre: '',
            headingBasic: true,
            heading: 3.3,
            headingPost: 'crore +',
            para: 'Customer Base'
        },
        {
            headingPre: 'INR',
            headingBasic: true,
            heading: 3.37,
            headingPost: 'lakh crore+',
            para: 'Assets'

        }
    ];

    useOptionsAndEndVal() {
        this.opts = {
            decimalPlaces: 0,
            separator: ',',
            duration: 3,
            decimal: '2',

        };
        this.opts1 = {
            decimalPlaces: 0,
            separator: ',',
            duration: 3,
            decimal: '2',
            useIndianSeparators: true,
        };
    }


    cardItem = [
        {
            headingPre: '',
            heading: 31,
            headingBasic: false,
            headingPost: '',
            para: 'Countries (Across Africa, Asia & UK)'
        },
        {
            headingPre: '',
            heading: 125163,
            headingBasic: false,
            headingPost: '+',
            para: 'Employees'
        },

        {
            headingPre: '',
            headingBasic: false,
            heading: 92,
            headingPost: 'million+',
            para: 'Lives touched'
        },
        {
            headingPre: 'Rand',
            heading: 1.4,
            headingBasic: true,
            headingPost: 'trillion+*',
            para: 'Assets',
            subText: 'Rand = INR XXX as on 31st December 2023'
        }
    ]

    imageCardData: any = [
        {
            "title": "Who <u>Are We?</u>",
            "sub_title": "<p>Shriram Wealth builds on Shriram Group's 50+ year legacy of trust and on Sanlam's 100+ years of global leadership to create simple, strategic wealth management solutions aligned with your unique goals.</p>",
            "image_url": "/assets/images/golbal.webp",
            "alt_text": "Who Are We?",
        }
    ];

}
